import React from 'react';
import {Icon, Toast} from 'antd-mobile';
import postData from '../../assets/xhr';
import model from '../../assets/model';
import SignaturePad from './signature_pad'
import './index.less';
const delStyle = {
    position: "absolute",
    right: "5px",
    top: "5px",
    color: "#FFF",
    backgroundColor: "rgba(0,0,0,0.3)",
    width: "35px",
    height: "35px",
    lineHeight: "35px",
    borderRadius: "35px",
    textAlign: "center",
    // zIndex: 5,
    cursor: "pointer"
}
const loadingStyle = {
    position: "absolute",
    right: "5px",
    top: "5px",
    color: "#FFF",
    width: "21px",
    height: "21px"
};
const fileReloadStyle = {
    position: 'absolute',
    right: 0,
    top: 0,
    left: 0,
    bottom: 0,
    'text-align': 'center',
    'line-height': '200px',
    cursor: 'pointer',
    'font-size': '28px',
    color: "#FFF",
    backgroundColor: "rgba(0,0,0,0.3)",
};
class Signature extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            api_name: props.api_name,
            upload: 0
        };
    }
    componentDidMount(){
      var me = this;
      var canvas = document.querySelector('#'+this.state.api_name);
      var signaturePad = new SignaturePad(canvas, {
        // It's Necessary to use an opaque color when saving image as JPEG;
        // this option can be omitted if only saving as PNG or SVG
        backgroundColor: 'rgb(255, 255, 255)',
        onEnd() {
          if (me.timeout) {
              clearTimeout(me.timeout);
          }
          me.timeout = setTimeout(() => {
              me.upload();
          }, 1000);
        }
      });

      me.canvas = canvas;
      me.signaturePad = signaturePad;

      // On mobile devices it might make more sense to listen to orientation change,
      // rather than window resize events.
      window.onresize = function () {
        me.resizeCanvas()
      };
      this.resizeCanvas();
    }
    // Adjust canvas coordinate space taking into account pixel ratio,
    // to make it look crisp on mobile devices.
    // This also causes canvas to be cleared.
  resizeCanvas() {
      var url = this.signaturePad.toDataURL();
      // When zoomed out to less than 100%, for some very strange reason,
      // some browsers report devicePixelRatio as less than 1
      // and only part of the canvas is cleared then.
      var ratio = Math.max(window.devicePixelRatio || 1, 1);

      // This part causes the canvas to be cleared
      this.canvas.width = this.canvas.offsetWidth * ratio;
      this.canvas.height = this.canvas.offsetHeight * ratio;
      this.canvas.getContext("2d").scale(ratio, ratio);

      this.signaturePad.fromDataURL(url);

      // This library does not listen for canvas changes, so after the canvas is automatically
      // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
      // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
      // that the state of this library is consistent with visual state of the canvas, you
      // have to clear it manually.
    }
    onDelete = ()=>{
        let onChange = this.props.onChange;
        this.signaturePad.clear();
        onChange([]);
        clearTimeout(this.timeout);
        this.xhr && this.xhr.abort && this.xhr.abort();
    }
    upload(){
        let canvas = this.canvas;
        let onChange = this.props.onChange;
        if (!HTMLCanvasElement.prototype.toBlob) {
            Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
                value: function (callback, type, quality) {

                    var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
                        len = binStr.length,
                        arr = new Uint8Array(len);

                    for (var i = 0; i < len; i++) {
                        arr[i] = binStr.charCodeAt(i);
                    }

                    callback(new Blob([arr], { type: type || 'image/png' }));
                }
            });
        }
        if (this.xhr){
            this.xhr.abort && this.xhr.abort();
            this.xhr = null;
        }
        canvas && canvas.toBlob((blob)=>{
            // 上传图片
            let formData = new FormData();
            formData.append('fileData', blob);
            formData.append('cardId', model.cardId);
            this.setState({
                upload: 1 //loading
            });
            onChange([{loading: 1}]);

            this.xhr = postData({
                url: '/smartform/rest/extApi/data/file/upload',
                data: formData,
                form: true,
                callback: (res) => {
                    let { code, data } = res;
                    if (code === 0) {
                        onChange([{
                            loading: 2,
                            name:  `${$st("签名")}.jpeg`,
                            tempPath: data.filePath
                        }])
                        this.setState({
                            upload: 0 //end
                        });
                    }else{
                        this.setState({
                            upload: 3 //重传
                        });
                        onChange([]);
                        Toast.info($st('上传签名失败'), 1.5);
                    }
                    this.xhr = null;
                },
                error:()=>{
                    Toast.info($st('上传签名失败'), 1.5);
                    onChange([]);
                    this.xhr = null;
                    this.setState({
                        upload: 3 //end
                    });
                }
            });
        }, 'image/jpeg')
    }
    render(){
        let state = this.state;
        let right = (<div className="btn-del" style={delStyle} onClick={this.onDelete.bind(this)}>
            <Icon type="cross" size="lg"></Icon>
        </div>);
        if (state.upload === 1){
            right = (<Icon type='loading' className="loading" style={loadingStyle}></Icon>);
        }else if(state.upload === 3) {
            right = (<div className="fileReload" style={fileReloadStyle} onClick={this.upload.bind(this)}>{$st("重传")}</div>);
        }
        return (
            <div className="signature_c">
                <canvas id={state.api_name}></canvas>
                {right}
            </div>
        )
    }
}
export default Signature;



// WEBPACK FOOTER //
// ./src/component/Signature/Signature.js